import clsx from "clsx";

interface IconProps {
	className?: string
	theme?: 'light' | 'dark'
}

export const FacebookIcon: React.FC<IconProps> = ({ className, theme= 'dark' }) => {
	return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 6 12"
      className={clsx(className, 'w-[1.2rem] h-[1.2rem]')}
    >
      <path
        fill={theme === 'light' ? '#FF77A8' : '#131313'}
        d="M1.417 2.327V3.979H.206v2.0202h1.211v6.0039h2.4854V5.9999h1.6684s.1564-.9686.2321-2.028H3.9127V2.5903c0-.2063.2705-.484.5387-.484h1.3551V.0032H3.9644c-2.6094 0-2.5475 2.022-2.5475 2.3237Z"
      />
    </svg>
  );
}